<pm-dialog
  dialogTitle="ANALYSIS.DETAILS.TITLE"
  size="md"
  dataTestid="analysis-configuration-details-dialog"
  [showSecondaryCta]="false"
  [primaryCtaButtonConfig]="primaryCtaButtonConfig"
  (crossClicked)="close()"
>
  <pm-analysis-configuration-summary [summary]="summary()" />
</pm-dialog>
